export default "assets/images/icons/link-arrow-efda3f9a.svg";